import { render, staticRenderFns } from "./ChangePixType.vue?vue&type=template&id=531e9558&scoped=true"
import script from "./ChangePixType.vue?vue&type=script&lang=js"
export * from "./ChangePixType.vue?vue&type=script&lang=js"
import style0 from "./ChangePixType.vue?vue&type=style&index=0&id=531e9558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e9558",
  null
  
)

export default component.exports